<template>
    <!-- eslint-disable vue/no-v-html -->
    <div class="sty-section" :class="bemFacets">
        <div class="grid--container">
            <sty-header :facets="['section-title']">
                <h2 class="u-reset u-reset__sty" :id="anchor" v-text="sectionTitle"/>
            </sty-header>
        </div>

        <div class="grid--container">
            <div class="grid--row sty-section--articles">
                <div class="grid--col sty-section--article">
                    <sty-header>
                        <h3 class="u-reset u-reset__sty">
                            Fonts
                        </h3>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <div class="grid--row">
                                <div class="grid--col sty-section--font-showcases" v-if="bridgeData">
                                    <div class="sty-section--font-showcase"
                                            v-for="(font, idx) in bridgeData"
                                            :key="idx">
                                        <h4 class="u-reset u-reset__sty sty-section--font-name">
                                            <span v-text="font.name"/>
                                            <span v-text="font.weight"/>
                                            <span v-text="font.style"/>
                                        </h4>
                                        <span class="sty-section--font-display"
                                                :class="['sty-section--font-display__' + font.mixin]"
                                                v-text="pangrams[idx]"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="grid--col sty-section--article">
                    <sty-header>
                        <h3 class="u-reset u-reset__sty">
                            Elements
                        </h3>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <sty-header :facets="['sub-title']">
                                <h4 class="u-reset u-reset__sty">
                                    Headings
                                </h4>
                            </sty-header>

                            <div class="grid--row">
                                <div class="grid--col sty-section--col" v-html="headings"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid--col sty-section--article">
                    <sty-header :facets="['sub-title']">
                        <h4 class="u-reset u-reset__sty">
                            Title
                        </h4>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <p class="u-reset title" v-html="shortText"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid--col sty-section--article">
                    <sty-header :facets="['sub-title']">
                        <h4 class="u-reset u-reset__sty">
                            Lead
                        </h4>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <p class="u-reset lead" v-html="rawText"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid--col sty-section--article">
                    <sty-header :facets="['sub-title']">
                        <h4 class="u-reset u-reset__sty">
                            Paragraph 1
                        </h4>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <p class="paragraph01" v-html="rawText"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid--col sty-section--article">
                    <sty-header :facets="['sub-title']">
                        <h4 class="u-reset u-reset__sty">
                            Paragraph 2
                        </h4>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <p class="u-reset paragraph02" v-html="rawText"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid--col sty-section--article">
                    <sty-header :facets="['sub-title']">
                        <h4 class="u-reset u-reset__sty">
                            Label
                        </h4>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <p class="u-reset label" v-html="shortText"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid--col sty-section--article">
                    <sty-header :facets="['sub-title']">
                        <h4 class="u-reset u-reset__sty">
                            Caption
                        </h4>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <div class="grid--row">
                                <div class="grid--col sty-section--col">
                                    <p class="u-reset caption" v-html="shortText"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid--col sty-section--article">
                    <sty-header :facets="['sub-title']">
                        <h4 class="u-reset u-reset__sty">
                            Text
                        </h4>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <div class="grid--row">
                                <div class="grid--col sty-section--col" v-html="paragraphs"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="grid--col sty-section--article">
                    <sty-header :facets="['sub-title']">
                        <h4 class="u-reset u-reset__sty">
                            Lists
                        </h4>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <div class="grid--row">
                                <div class="grid--col sty-section--list" v-html="ulList"/>
                                <div class="grid--col sty-section--list" v-html="olList"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import StyHeader from 'framework/styleguide/header';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { TYPO_HEADINGS, TYPO_OL_LIST, TYPO_PANGRAMS, TYPO_PARAGRAPHS, TYPO_UL_LIST, TYPO_RAW_PARAGRAPHS, TYPO_SHORT_TEXT } from './data';

    export default {
        components: {
            StyHeader,
        },
        mixins: [
            bemMixin('sty-section'),
        ],
        props: {
            anchor: {
                type: String,
                required: true,
            },
            sectionTitle: {
                type: String,
                required: true,
            },
            bridgeData: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                pangrams: TYPO_PANGRAMS,
                paragraphs: TYPO_PARAGRAPHS,
                headings: TYPO_HEADINGS,
                ulList: TYPO_UL_LIST,
                olList: TYPO_OL_LIST,
                rawText: TYPO_RAW_PARAGRAPHS,
                shortText: TYPO_SHORT_TEXT,
            };
        },
    };
</script>
